import { postRequest } from "../../web";

const LOCATION_HIERARCHY_URL = "/api/location/location-hierarchy";
const MANAGE_SETTINGS_URL = "api/system/user-setting";
const LOCATION_SELECTOR_KEY = "location_selector";

export function updateLocationSelectedIds(list: string) {
  const payload = {
    Key: LOCATION_SELECTOR_KEY,
    Value: list,
  };

  return postRequest<any, any>(`${MANAGE_SETTINGS_URL}`, payload);
}

export function readLocationList() {
  return postRequest<any, any>(`${LOCATION_HIERARCHY_URL}/list`);
}
